import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from '../styles/GlobalStyle';
import CarregandoDna from './ui/CarregandoDna';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  fullScreen?: boolean;
}

/*
 * A espera do portal inteiro é a dupla hélice (10/10, pedido do Valdair: "o load era para ser global").
 * Antes era um círculo; a hélice só existia na carga da ficha. Toda espera de tela cheia (login, conferência
 * do acesso, o pedaço da página que o navegador ainda baixa) e as esperas dentro das telas passam por aqui.
 *
 * Tela cheia: nas telas com o menu lateral (admin e médico) o palco desconta o menu (aberto ou recolhido) e o
 * cabeçalho do celular, para a hélice ficar no mesmo ponto em que a ficha a desenha (AdminLayout centralizado)
 * e não pular quando o layout chega. Na ficha do paciente ela vem com o nome da Essentia, como na carga da ficha.
 */
const naFichaDoPaciente = () =>
  typeof window !== 'undefined' && /^\/admin\/patients\/[^/]+/.test(window.location.pathname);
const comMenuLateral = () =>
  typeof window !== 'undefined'
  && /^\/(admin|doctor)(\/|$)/.test(window.location.pathname)
  && !/^\/admin\/(login|fullscript\/callback)/.test(window.location.pathname);
const menuRecolhido = () => {
  try { return localStorage.getItem('sidebar_collapsed') === 'true'; } catch { return false; }
};

const Palco = styled.div<{ $menu: number }>`
  position: fixed; inset: 0; z-index: 9999; box-sizing: border-box;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: ${theme.spacing.lg} ${theme.spacing.md} ${theme.spacing.lg} calc(${p => p.$menu}px + ${theme.spacing.md});
  background: ${theme.colors.background};
  @media (max-width: 768px) {
    padding: ${p => (p.$menu ? '60px' : theme.spacing.lg)} ${theme.spacing.md} ${theme.spacing.lg};
  }
`;

const NoMeio = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.lg};
`;

const alturaDaHelice = { small: 48, medium: 72, large: 96 };

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message,
  fullScreen = false,
}) => {
  const { i18n } = useTranslation();
  if (fullScreen) {
    const ficha = naFichaDoPaciente();
    return (
      <Palco $menu={comMenuLateral() ? (menuRecolhido() ? 68 : 230) : 0}>
        <CarregandoDna
          titulo={ficha ? 'Essentia' : undefined}
          mensagem={ficha
            ? (i18n.language === 'pt' ? 'Preparando inteligência clínica…' : 'Preparing clinical intelligence…')
            : message}
        />
      </Palco>
    );
  }
  return (
    <NoMeio>
      <CarregandoDna tamanho={alturaDaHelice[size]} mensagem={message} />
    </NoMeio>
  );
};

export default LoadingSpinner;
